export enum TILE_VARIANTS {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  NEUTRAL = 'GRAY',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  TERTIARY = 'TERTIARY',
  CHROME = 'CHROME',
  DISCORD = 'DISCORD',
}
